import type { QueryClient } from '@tanstack/react-query';
import { createRootRouteWithContext, Outlet, useLocation } from '@tanstack/react-router';
import { ImportSheetProvider } from '../app/ImportSheetProvider.tsx';
import { TabBar } from '../app/TabBar.tsx';
import { UpdatePrompt } from '../app/UpdatePrompt.tsx';
import { AddPasskeyScreen } from '../features/auth/AddPasskeyScreen.tsx';
import { LoginScreen } from '../features/auth/LoginScreen.tsx';
import { useAuth } from '../lib/auth.ts';
import { useSync } from '../lib/sync.ts';

export const Route = createRootRouteWithContext<{ queryClient: QueryClient }>()({
  component: RootLayout,
});

/** Screens reachable without a session (they bring their own token). */
const PUBLIC_PATHS = ['/setup', '/login-link', '/invite/'];

function RootLayout() {
  return (
    <>
      <Screen />
      <UpdatePrompt />
    </>
  );
}

function Screen() {
  const { pathname } = useLocation();
  const auth = useAuth();
  const user = auth.data?.user;
  useSync(user && !auth.data?.mustAddPasskey ? `${user.household.id}:${user.id}` : undefined);

  if (PUBLIC_PATHS.some((path) => pathname.startsWith(path))) return <Outlet />;
  if (auth.isPending) return <div className="splash" aria-busy="true" />;
  if (!auth.data?.user) return <LoginScreen />;
  if (auth.data.mustAddPasskey) return <AddPasskeyScreen />;
  return (
    <ImportSheetProvider>
      <div className="app-shell">
        <Outlet />
        <TabBar />
      </div>
    </ImportSheetProvider>
  );
}
